import { DurationFilter } from '../enums/duration-filter.enum';
import { ReviewsFilter } from '../interfaces/reviews-filter';

export const defaultFilter: ReviewsFilter = {
    durationFilter: DurationFilter.AllTime,
};
